import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetSpeciesNavContent, GetSpeciesNavContentResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";


const getData = (response?: SWRResponse<GetSpeciesNavContentResponse, GetSpeciesNavContentResponse>) => response?.data?.items;
const getError = (response?: SWRResponse<GetSpeciesNavContentResponse, GetSpeciesNavContentResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetSpeciesNavContentResponse, GetSpeciesNavContentResponse>) => ({});

const useGetSpeciesNavContent = (query?: Partial<GetSpeciesNavContent>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetSpeciesNavContent(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetSpeciesNavContent;